import gql from 'graphql-tag';

export const GET_GUARANTOR_SUMMARY = gql`
  query GetGuarantorSummary {
    guarantor {
      amountDue
      dueStatus
      totalEncounters
      encounters(limit: 3) {
        id
        dischargeDate
        balance
        paymentPlan
        visitPayEligible
        patient {
          id
          firstName
          lastName
        }
      }
    }
  }
`;
